import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=70627c7c&scoped=true&"
import script from "./AlertMessage.vue?vue&type=script&lang=js&"
export * from "./AlertMessage.vue?vue&type=script&lang=js&"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=70627c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70627c7c",
  null
  
)

export default component.exports